window.addEventListener("load", function () {

  var article = document.querySelector('#content .article-detail');
  if (!article) return;

  // ===== Tab nội bộ trong bài (Sự Kiện / Đăng nhập / Tin Tức) =====
  // CSS ẩn .tab__detail mặc định -> JS hiện tab đang chọn
  var tabs = article.querySelectorAll('#tabHeader a');
  var details = article.querySelectorAll('.tab__detail');

  function activate(href) {
    details.forEach(function (d) {
      d.style.display = ('#' + d.id === href) ? 'block' : 'none';
    });
    tabs.forEach(function (t) {
      t.classList.toggle('active', t.getAttribute('data-href') === href);
    });
    // Đổi tab -> chiều cao nội dung đổi -> tính lại chiều cao trang (tránh dư/thiếu)
    if (typeof window.MS__fitHeight === 'function') window.MS__fitHeight();
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      activate(t.getAttribute('data-href'));
    });
  });

  // Mặc định mở tab đầu tiên
  if (tabs.length) activate(tabs[0].getAttribute('data-href'));
});
